const administrator = {
	tabs: {
		manage_permissions: "Manage permissions",
		user_activate: "Activate Account",
		user_create_new: "Add New User",
		user_management: "Manage Users",
	},
	title: "Administrator",
	user_management: {
		active: {
			block_modal: {
				description: "Are you sure you want to block <strong>{{username}}</strong>?",
				status: {
					success: "User <strong>{{username}}</strong> has been successfully blocked!",
					unknown:
						"User <strong>{{username}}</strong> cannot be blocked at the moment. Please try again or contact our support department.",
				},
				title: "Block User",
			},
			button_add_user: "Add User",
			deblock_modal: {
				description: "Are you sure you want to unblock <strong>{{username}}</strong>?",
				status: {
					success: "User <strong>{{username}}</strong> has been successfully unblocked!",
					unknown:
						"User <strong>{{username}}</strong> cannot be unblocked at the moment. Please try again or contact our support department.",
				},
				title: "Unblock User",
			},

			delete_modal: {
				description: "Are you sure you want to delete <strong>{{username}}</strong>?",
				status: {
					success: "User <strong>{{username}}</strong> has been successfully deleted!",
					unknown:
						"User <strong>{{username}}</strong> cannot be deleted at the moment. Please try again or contact our support department.",
				},
				title: "Delete User",
			},
			description:
				"This is where users who have signed up on the portal are located. Here, users can be added, edited and deleted.",
			title: "Active Users",
		},
		add_user_first: {
			description:
				"After that, only use this new account to log in. Then, through your new account, create accounts for any colleagues and give them the appropriate permissions.",
			title:
				"You cannot currently leave this page. You need to create a personal account (user) first.",
		},
		categories: {
			action: {
				update: "Update tags",
			},
			description:
				"Select the label or labels you wish to assign to a user here. Labels are only visual, as they are used for labeling the role or task a user performs within your company.",
			placeholder: "Select label(s)",
			status: { success: "Labels successfully linked to the user" },
			title: "Select labels",
		},
		create: {
			sign_in_details: {
				description: "Enter the email address and username for the new user here.",
				title: "Enter Sign-in Details",
			},
			status: {
				email_address_invalid:
					"The email address you entered is invalid. Please use a valid email address.",
				invalid:
					"Your request to add a new user has been rejected. Please try again or contact our support department.",
				success:
					"New user has been successfully added. An invitation has been sent to the following e-mail address:",
				unknown:
					"An error occurred while adding a new user. Please try again or contact our support department.",
				username_in_use: "The username you entered is already in use.",
			},
			user_details: {
				description:
					"Enter the account details for the new user here. The user can change these details after registration.",
				title: "Enter Account Details",
			},
		},

		/* --------------------------------- INVITE --------------------------------- */
		invite: {
			button: "Add user quickly",
			description:
				"This section lists the known contacts who have been found but do not yet have a portal account. You can easily create an account for them by clicking the ‘Quick Create’ button.",
			empty_table: "No known contacts have been found.",
			title: "Known Contacts who do not have a portal account",
		},
		pending: {
			delete_modal: {
				description:
					"Are you sure you want to cancel the invitation for user <strong>{{username}}</strong>?",
				status: {
					success: "Invitation successfully canceled for user <strong>{{username}}</strong>!",
					unknown:
						"The invitation for user <strong>{{username}}</strong> cannot be canceled at the moment. Please try again or contact our support department.",
				},
				title: "Cancel Invitation",
			},
			description:
				"This section contains users who have been invited but have not yet accepted the invitation. Within this section, invitations can be canceled and resent.",
			empty_table: "No pending invitations found.",
			resend_modal: {
				description:
					"Are you sure you want to resend the invitation to user <strong>{{username}}</strong>?",
				status: {
					success: "Invitation successfully resent to user <strong>{{username}}</strong>!",
					unknown:
						"A new invitation cannot be sent to user <strong>{{username}}</strong> at the moment. Please try again or contact our support department.",
				},
				title: "Resend Invitation",
			},
			title: "Pending Users",
		},
		permissions: {
			assign: {
				active: "Changing permissions applies to user <strong>{{username}}</strong>.",
				"allow-all": "Allow All",
				description: `In this section, permissions can be assigned to the user. Permissions are grouped by categories, and each category can be expanded by clicking on it. 
            Permissions are always applicable only to the debtors to which this user is assigned.`,
				title: "Assign Permissions to the User",
			},
			categories: {
				admin: "Admin Rights",
				company: "Company Rights",
			},
			clone: {
				description:
					"By taking on the permissions of another user, you can easily assign permissions to the new user.",
				placeholder: "Take Over User Permissions",
				title: "Clone User Permissions",
			},
			description: "Here, you can manage the permissions of the user.",
			permission_titles: {
				admin: {
					user_create: "Create Users",
					user_delete: "Delete Users",
					user_read: "View Users",
					user_update: "Edit Users",
				},
				company: {
					billing_invoices_read: "View Invoices",
					billing_orders_read: "View Orders",
					details_read: "View Details",
					details_update: "Edit Details",
				},
			},
			title: "Manage User Permissions",
		},
		update: {
			success: "The permissions have been successfully updated.",
		},
	},
};

export default administrator;
